import { render, staticRenderFns } from "./SidebarGroupItem.vue?vue&type=template&id=dc3c62da&"
import script from "./SidebarGroupItem.vue?vue&type=script&lang=js&"
export * from "./SidebarGroupItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports